import { Dispatch } from 'react';
import { GlobalVariables } from '../GlobalVariables';
import { getFileBasicInfo } from '../util/FileUtils';
import { useDispatch } from 'react-redux';
import { FileInfo } from '../redux/general/files';
import { ActionCreatorWithOptionalPayload } from '@reduxjs/toolkit';

export const useFileUpload = ({
    appendFilesInfo,
    removeFile,
}: {
    appendFilesInfo: ActionCreatorWithOptionalPayload<FileInfo[], string>;
    removeFile: ActionCreatorWithOptionalPayload<string, string>;
}) => {
    const dispatch: Dispatch<unknown> = useDispatch();

    const onDropFile = async (droppedFile: File, idPrefix = '') => {
        if (droppedFile) {
            const hash = GlobalVariables.addFile(droppedFile);
            const basicInfo = await getFileBasicInfo(droppedFile);
            const fileInfoData = {
                id: idPrefix + hash,
                ...basicInfo,
            };

            dispatch(appendFilesInfo([fileInfoData]));
        }
    };

    const onInputFiles = async (fileArray: File[], idPrefix = '') => {
        const fileInfos = await Promise.all(
            fileArray.map(async file => {
                const hash = GlobalVariables.addFile(file);
                const basicInfo = await getFileBasicInfo(file);
                return {
                    id: idPrefix + hash,
                    ...basicInfo,
                };
            }),
        );
        dispatch(appendFilesInfo(fileInfos));
    };

    const onRemoveFile = (id: string) => {
        GlobalVariables.removeFileById(id);
        dispatch(removeFile(id));
    };

    return {
        onDropFile,
        onRemoveFile,
        onInputFiles,
    };
};
